import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const Service = {}
Service.getDataAll = function (token) {

    return fetch({
        url: '/ref/kebutuhan_khusus',
        method: 'get',
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

Service.getDataByID = function (token,id) {

    return fetch({
        url: '/ref/kebutuhan_khusus',
        method: 'get',
        params: {
            "id_kebutuhan":id
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

export default Service;
